import template from "./notices-filters.html";
import "./notices-filters.less";

function controller() {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.severityOptions = [
			{ key: "", display: "All" },
			{ key: "INFO", display: "Info" },
			{ key: "WARNING", display: "Warning" },
			{ key: "URGENT", display: "Urgent" },
			{ key: "CRITICAL", display: "Critical" }
		];
		ctrl.selectedSeverity = ctrl.severityOptions[0];

		ctrl.statusOptions = [
			{ key: "", display: "All" },
			{ key: "active", display: "Active" },
			{ key: "scheduled", display: "Scheduled" },
			{ key: "expired", display: "Expired" }
		];
		ctrl.selectedStatus = ctrl.statusOptions[1];
	};

	ctrl.onSearchChange = () => {
		if(ctrl.onFilterChange) {
			ctrl.onFilterChange({
				search: ctrl.search,
				severity: ctrl.selectedSeverity.key,
				status: ctrl.selectedStatus.key
			});
		}
	};

	ctrl.onSeverityChange = () => {
		if(ctrl.onFilterChange) {
			ctrl.onFilterChange({
				search: ctrl.search,
				severity: ctrl.selectedSeverity.key,
				status: ctrl.selectedStatus.key
			});
		}
	};

	ctrl.onStatusChange = () => {
		if(ctrl.onFilterChange) {
			ctrl.onFilterChange({
				search: ctrl.search,
				severity: ctrl.selectedSeverity.key,
				status: ctrl.selectedStatus.key
			});
		}
	};

	ctrl.clearSearch = () => {
		ctrl.search = null;
		ctrl.onSearchChange();
	};

	ctrl.resetFilters = () => {
		ctrl.search = null;
		ctrl.selectedSeverity = ctrl.severityOptions[0];
		ctrl.selectedStatus = ctrl.statusOptions[0];
		if(ctrl.onFilterChange) {
			ctrl.onFilterChange({
				search: null,
				severity: "",
				status: ""
			});
		}
	};
}

export default angular
	.module("vesl.screens.notices.filters", [])
	.component("noticesFilters", {
		template,
		controller,
		bindings: {
			onFilterChange: "<",
			onCollapse: "&",
			isCollapsed: "=",
			isMobile: "<"
		}
	}).name;
